import { Spacer } from '@dot/design-system';
import { useTranslation } from 'react-i18next';

import { Heading } from '../../styles';

import { Loader } from '@/atoms/Loader/Loader';

export const Loading = () => {
  const { t } = useTranslation();

  return (
    <>
      <Loader />
      <Spacer $top={0.625}>
        <Heading>{t('steps.mobileRedirect.pending.heading')}</Heading>
      </Spacer>
    </>
  );
};
